import React, { Component } from 'react'
import classNames from 'classnames'
import { string, func, oneOfType, number, bool } from 'prop-types'
import SSRIcon from '@ingka/ssr-icon'
import * as paths from '@ingka/ssr-icon/icons'

require('./Icon.scss')

class Icon extends Component {
    constructor(props) {
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    onClick(e) {
        if (this.props.onClick) {
            this.props.onClick(e)
        }
    }

    render() {
        const { code, label, className, onClick, svg } = this.props
        const toggledClassnames = {
            label,
            onClick,
            svg,
        }

        // Show Missing Icon text if icon not found
        const ssrContent = paths[code] ? <SSRIcon paths={paths[code]} /> : 'MI'
        return (
            <div className={classNames('Icon', toggledClassnames, className)} data-label={label} onClick={this.onClick}>
                {svg ? <img src={`${ASSET_BUCKET}/icons/${code}.svg`} alt={label} draggable={false} /> : ssrContent}
            </div>
        )
    }
}
Icon.defaultProps = {
    onClick: null,
    label: null,
    className: null,
    svg: false,
}
Icon.propTypes = {
    code: string.isRequired,
    onClick: func,
    label: oneOfType([string, number]),
    className: string,
    svg: bool,
}

export default Icon
